import { useState } from "react";
import { usePage } from "@inertiajs/react";
import useTranslation from "@hooks/use_translation";
import DreamJobIcon from "@/sprout/icons/dream_job";
import { dreamJobStatusText } from "@/utils/date_utils";
import "@/stylesheets/dream_job_icon.scss";
import { Body } from "@sprout/typography";
import DreamJobPickerModal from "@components/applications/dream_job_picker_modal";
import { TertiaryButton } from "@sprout/buttons";

export const DREAM_JOB_CALLOUT_DISMISSED_KEY = "dreamJobCalloutDismissedMonth";

export const dreamJobCalloutDismissedValue = (userId?: number) => {
  const now = new Date();
  const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  return `${userId ?? "anonymous"}:${month}`;
};

type Props = {
  className?: string;
};

const DreamJobCallout = ({ className }: Props) => {
  const { t } = useTranslation("applications");
  const { currentUserId } = usePage<{ currentUserId?: number }>().props;
  const [dismissed, setDismissed] = useState(
    () =>
      localStorage.getItem(DREAM_JOB_CALLOUT_DISMISSED_KEY) ===
      dreamJobCalloutDismissedValue(currentUserId),
  );

  const handleDismiss = () => {
    localStorage.setItem(
      DREAM_JOB_CALLOUT_DISMISSED_KEY,
      dreamJobCalloutDismissedValue(currentUserId),
    );
    setDismissed(true);
  };

  if (dismissed) {
    return null;
  }

  return (
    <div
      className={`w-full bg-marigold-25 px-6 py-4 border border-marigold-e50 rounded-lg ${className ?? ""}`}
    >
      <div className="flex flex-col justify-between gap-3 items-start h-full">
        <div className="flex gap-1 items-center">
          <div className="bg-marigold-e50 dream-job-icon">
            <DreamJobIcon size="sm" />
          </div>
          <p className="text-xs ml-1">
            {dreamJobStatusText((key, opts) => t(`dream_job_callout.${key}`, opts))}
          </p>
        </div>
        <Body medium>{t("dream_job_callout.title")}</Body>
        <p className="text-sm">{t("dream_job_callout.description")}</p>
        <div className="flex items-center gap-4">
          <DreamJobPickerModal />
          <TertiaryButton secondary onClick={handleDismiss}>
            {t("dismiss")}
          </TertiaryButton>
        </div>
      </div>
    </div>
  );
};

export default DreamJobCallout;
